import { render, staticRenderFns } from "./ClientDisplayConfig.vue?vue&type=template&id=3d0a0e3c&"
import script from "./ClientDisplayConfig.vue?vue&type=script&lang=js&"
export * from "./ClientDisplayConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports